import { c as _c } from "react/compiler-runtime";
import React from "react";
import { NavbarClient, NavbarSkeletonResponsive } from "./NavbarClient";
export function Navbar(t0) {
  const $ = _c(14);
  const {
    isLoggedIn,
    userName,
    logout,
    isLoadingCart,
    isLoadingAccount,
    cart,
    isLoading,
    menuItems,
    popularSearches,
    matchingCategories,
    loadingPopularSearches,
    getPopularSearchesData,
    clearPopularSearchesData
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <NavbarSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== cart || $[2] !== clearPopularSearchesData || $[3] !== getPopularSearchesData || $[4] !== isLoadingAccount || $[5] !== isLoadingCart || $[6] !== isLoggedIn || $[7] !== loadingPopularSearches || $[8] !== logout || $[9] !== matchingCategories || $[10] !== menuItems || $[11] !== popularSearches || $[12] !== userName) {
    t1 = <header className="relative h-[75px] max-w-screen-2xl 2xl:px-0 px-4 mx-auto border-b"><NavbarClient isLoggedIn={isLoggedIn} userName={userName} logout={logout} isLoadingCart={isLoadingCart} isLoadingAccount={isLoadingAccount} cart={cart} menuItems={menuItems} popularSearches={popularSearches} matchingCategories={matchingCategories} loadingPopularSearches={loadingPopularSearches} getPopularSearchesData={getPopularSearchesData} clearPopularSearchesData={clearPopularSearchesData} /></header>;
    $[1] = cart;
    $[2] = clearPopularSearchesData;
    $[3] = getPopularSearchesData;
    $[4] = isLoadingAccount;
    $[5] = isLoadingCart;
    $[6] = isLoggedIn;
    $[7] = loadingPopularSearches;
    $[8] = logout;
    $[9] = matchingCategories;
    $[10] = menuItems;
    $[11] = popularSearches;
    $[12] = userName;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
}
export function NavbarSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <header className="relative h-[75px] max-w-screen-2xl 2xl:px-0 px-4 mx-auto border-b"><nav className="flex items-center w-full h-[75px]"><NavbarSkeletonResponsive /></nav></header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}